import { IncomingHttpHeaders, ServerResponse, IncomingMessage } from 'http';
import { tl } from '../utils/adobeAnalyticsUtil';
import {
  SIGNUP_WITH_RESUME_COOKIE_KEY,
  SIGNUP_WITH_RESUME_COOKIE_TERM,
  SignupWithResumeABTestPattern,
} from '../constants/signupWithResume';
import { getAbtestGroupNo } from '../services/getAbtestGroupNoAPI';
import { createAbTestCookie } from './createAbTestCookie';

/**
 * SKY2257_レジュメUP会員登録_ABテスト
 * imp計測
 * @param signupWithResumeAbtestValue ABテスト振り分け値
 */
export const measureSignupWithResumeAbtestAnalytics = (
  signupWithResumeAbtestValue: number
) => {
  switch (signupWithResumeAbtestValue) {
    case SignupWithResumeABTestPattern.Original:
      tl('web_resume_form_original', {});
      break;
    case SignupWithResumeABTestPattern.TestPattern:
      tl('web_resume_form_test', {});
      break;
    default:
      break;
  }
};

/**
 * SKY2257_レジュメUP会員登録_ABテスト
 * ABテスト振り分け値取得
 * @param headers
 * @param res
 * @returns ABテスト振り分け値
 */
export const getSignupWithResumeAbtestValue = async (
  headers: IncomingHttpHeaders,
  res: ServerResponse<IncomingMessage>
): Promise<number> => {
  const cookieValue = createAbTestCookie(
    headers,
    res,
    SIGNUP_WITH_RESUME_COOKIE_KEY,
    SIGNUP_WITH_RESUME_COOKIE_TERM
  );
  return (
    (await getAbtestGroupNo('web1_signup_with_resume', headers, cookieValue)) ??
    SignupWithResumeABTestPattern.Original
  );
};
